"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecordDiscList = getRecordDiscList;
var _request = _interopRequireDefault(require("@/utils/request"));
function getRecordDiscList(query) {
  return (0, _request.default)({
    url: '/system/recorddisc/',
    method: 'get',
    params: query
  });
}